import { trafficFineConstants } from "../_constants";

export const policeStationsListRequest = (payload, meta) => {
  const action = {
    type: trafficFineConstants.POLICE_STATION_LIST_REQUEST,
    payload,
  };

  if (meta && Object.keys(meta).length > 0) {
    action.meta = meta;
  }

  return action;
};

export const policeStationsListComplete = (payload) => {
  return {
    type: trafficFineConstants.POLICE_STATION_LIST_COMPLETE,
    payload,
  };
};

export const policeStationsListError = (payload) => {
  return {
    type: trafficFineConstants.POLICE_STATION_LIST_ERROR,
    payload,
  };
};

export const finesListRequest = (payload, meta) => {
  const action = {
    type: trafficFineConstants.FINES_LIST_REQUEST,
    payload,
  };

  if (meta && Object.keys(meta).length > 0) {
    action.meta = meta;
  }

  return action;
};

export const finesListComplete = (payload) => {
  return {
    type: trafficFineConstants.FINES_LIST_COMPLETE,
    payload,
  };
};

export const finesListError = (payload) => {
  return {
    type: trafficFineConstants.FINES_LIST_ERROR,
    payload,
  };
};

export const trafficFinePayableListRequest = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_PAYABLE_LIST_REQUEST,
    payload,
  };
};

export const trafficFinePayableListComplete = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_PAYABLE_LIST_COMPLETE,
    payload,
  };
};

export const trafficFinePayableListError = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_PAYABLE_LIST_ERROR,
    payload,
  };
};

export const trafficFineSetPayableAccounts = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_SET_PAYABLE_ACCOUNTS,
    payload,
  };
};

export const TrafficFineSetPayableCards = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_SET_PAYABE_CARDS,
    payload,
  };
};

export const trafficFineValidateAmountRequest = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_VALIDATE_AMOUNT_REQUEST,
    payload,
  };
};

export const trafficFineValidateAmountComplete = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_VALIDATE_AMOUNT_COMPLETE,
    payload,
  };
};

export const trafficFineValidateAmountError = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_VALIDATE_AMOUNT_ERROR,
    payload,
  };
};

export const clearConfirmationData = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_CLEAR_VALIDATION_AMOUNT_DATA,
    payload,
  };
};

export const clearFineFormData = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_CLEAR_FINE_FORM_DATA,
    payload,
  };
};

export const trafficFinePayBillRequest = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_PAYBILL_REQUEST,
    payload,
  };
};

export const trafficFinePayBillComplete = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_PAYBILL_COMPLETE,
    payload,
  };
};

export const trafficFinePayBillError = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_PAYBILL_ERROR,
    payload,
  };
};

export const trafficSetSelectedPoliceStation = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_SELECTED_POLICE_STATION,
    payload,
  };
};

export const clearTrafficPayBillData = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_CLEAR_PAY_BILL_DATA,
    payload,
  };
};

export const trafficFineOTPConfirmRequest = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_OTP_CONFIRM_REQUEST,
    payload,
  };
};

export const trafficFineOTPConfirmComplete = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_OTP_CONFIRM_COMPLETE,
    payload,
  };
};

export const trafficFineOTPConfirmError = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_OTP_CONFIRM_ERROR,
    payload,
  };
};

export const trafficFineOTPResendRequest = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_OTP_RESEND_REQUEST,
    payload,
  };
};

export const trafficFineOTPResendComplete = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_OTP_RESEND_COMPLETE,
    payload,
  };
};

export const trafficFineOTPResendError = (payload) => {
  return {
    type: trafficFineConstants.TRAFFIC_FINE_OTP_RESEND_ERROR,
    payload,
  };
};
